export default "__VITE_ASSET__BQN3Wcgi__"